import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Youtube, Send, MessageCircle, Music2, Phone } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { api } from '../api/client';
import { toast } from 'sonner';
import { useSite } from '../context/SiteContext';

const Footer = () => {
  const { site, pages } = useSite();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try { await api.newsletter(email); toast.success('Thanks for subscribing!'); setEmail(''); } catch { toast.error('Could not subscribe'); }
    finally { setSubmitting(false); }
  };
  const contact = site?.contact || {};
  const socials = site?.socials || {};
  const footerPages = (pages || []).filter((p) => p.show_in_footer);
  const customFooterMenu = site?.footer_menu || [];
  const brandName = site?.brand?.site_name || 'We Supply Smoke';

  return (
    <footer className="bg-black border-t border-zinc-900 mt-24">
      <div className="max-w-[1480px] mx-auto px-6 py-20 grid md:grid-cols-4 gap-10">
        <div>
          <h4 className="serif-italic text-[#d4af37] text-2xl mb-4">Come Visit</h4>
          <p className="text-zinc-400 leading-relaxed text-sm">{contact.address}</p>
          {contact.business_hours && <p className="text-zinc-500 text-xs mt-3">{contact.business_hours}</p>}
        </div>
        <div>
          <h4 className="serif-italic text-[#d4af37] text-2xl mb-4">Contact</h4>
          {contact.phone && <p className="text-zinc-400 mb-2 text-sm">{contact.phone}</p>}
          {contact.email && <p className="text-zinc-400 mb-4 text-sm">{contact.email}</p>}
          <div className="flex gap-3 text-zinc-400 flex-wrap">
            {socials.instagram && <a href={socials.instagram} target="_blank" rel="noreferrer" className="hover:text-[#d4af37]" aria-label="Instagram"><Instagram className="h-5 w-5" /></a>}
            {socials.facebook && <a href={socials.facebook} target="_blank" rel="noreferrer" className="hover:text-[#d4af37]" aria-label="Facebook"><Facebook className="h-5 w-5" /></a>}
            {socials.twitter && <a href={socials.twitter} target="_blank" rel="noreferrer" className="hover:text-[#d4af37]" aria-label="Twitter"><Twitter className="h-5 w-5" /></a>}
            {socials.youtube && <a href={socials.youtube} target="_blank" rel="noreferrer" className="hover:text-[#d4af37]" aria-label="YouTube"><Youtube className="h-5 w-5" /></a>}
            {socials.telegram && <a href={socials.telegram} target="_blank" rel="noreferrer" className="hover:text-[#d4af37]" aria-label="Telegram"><Send className="h-5 w-5" /></a>}
            {socials.snapchat && <a href={socials.snapchat} target="_blank" rel="noreferrer" className="hover:text-[#d4af37]" aria-label="Snapchat"><MessageCircle className="h-5 w-5" /></a>}
            {socials.tiktok && <a href={socials.tiktok} target="_blank" rel="noreferrer" className="hover:text-[#d4af37]" aria-label="TikTok"><Music2 className="h-5 w-5" /></a>}
            {socials.whatsapp && <a href={socials.whatsapp} target="_blank" rel="noreferrer" className="hover:text-[#d4af37]" aria-label="WhatsApp"><Phone className="h-5 w-5" /></a>}
          </div>
        </div>
        <div>
          <h4 className="serif-italic text-[#d4af37] text-2xl mb-4">Quick links</h4>
          <ul className="space-y-2">
            <li><Link to="/shop" className="text-zinc-400 hover:text-[#d4af37] text-sm">Shop all</Link></li>
            {footerPages.map((p) => <li key={p.id}><Link to={`/p/${p.slug}`} className="text-zinc-400 hover:text-[#d4af37] text-sm">{p.title}</Link></li>)}
            {customFooterMenu.map((m) => <li key={`${m.label}|${m.href}`}><a href={m.href} target={m.target} className="text-zinc-400 hover:text-[#d4af37] text-sm">{m.label}</a></li>)}
          </ul>
        </div>
        <div>
          <h4 className="serif-italic text-[#d4af37] text-2xl mb-4">Newsletter</h4>
          <p className="text-zinc-500 text-sm mb-3">Get drops, deals & flavor restock alerts.</p>
          <form className="flex gap-2" onSubmit={subscribe}>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className="bg-transparent border-zinc-800 text-zinc-200 placeholder:text-zinc-600 h-11" />
            <Button type="submit" disabled={submitting} className="btn-gold h-11 px-5">{submitting ? '…' : 'Subscribe'}</Button>
          </form>
        </div>
      </div>
      <div className="border-t border-zinc-900 py-6 px-6 text-center text-zinc-500 text-sm">
        © {new Date().getFullYear()} {brandName}. All rights reserved. <span className="text-zinc-600">Nicotine is addictive. 18+ only.</span>
      </div>
    </footer>
  );
};

export default Footer;
